import React from 'react';
import {Map} from 'immutable';
import {
  DATA_ATTR_COMMERCE_SKU_ID,
  ADD_TO_CART_STATES,
  DATA_ATTR_COMMERCE_PRODUCT_ID,
  STATE,
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_ADD_TO_CART_FORM,
} from '@packages/systems/commerce/constants';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {SHARED_FORM_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import withAttribute from './withAttribute';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
import {EvaluatedData} from '@packages/systems/render';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const CommerceAddToCartForm = Atom.createRender(
  ({
    attributes,
    classes,
    context,
    data,
    generateAttributes,
    renderChild,
    skuId,
  }) => {
    const attributesWithSkuId = skuId
      ? attributes.merge(
          Map({
            [DATA_ATTR_COMMERCE_SKU_ID]: skuId,
            [DATA_ATTR_COMMERCE_PRODUCT_ID]: context.get(
              DATA_ATTR_COMMERCE_PRODUCT_ID,
              ''
            ),
          })
        )
      : attributes;

    const styledAttributes =
      context.get(STATE) !== ADD_TO_CART_STATES.OUT_OF_STOCK
        ? attributesWithSkuId
        : attributesWithSkuId.merge(styleDisplayNone);

    return (
      <form {...generateAttributes(styledAttributes, classes)}>
        {getChildren(data).map((child: EvaluatedData) => renderChild(child))}
      </form>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Default State',
  showEmpty: true,
  uiStateOnSelected: ADD_TO_CART_STATES.DEFAULT,
  constraints: {
    pinToParent: true,
    descendants: [
      ...SHARED_FORM_CONSTRAINTS_DESCENDANTS,
      {
        is: 'CommerceAddToCartButton',
        rule: 'ExactlyOne',
      },
      {
        is: 'CommerceAddToCartQuantityInput',
        rule: 'ExactlyOne',
        messages: {
          remove: 'Quantity can be hidden in Add To Cart Settings.',
        },
      },
      {
        is: [
          'CommerceAddToCartOptionList',
          'CommerceAddToCartOptionListWithSelectorTypes',
        ],
        name: 'Option List',
        rule: 'ExactlyOne',
      },
      {
        is: 'CommerceBuyNowButton',
        rule: 'ZeroOrOne',
      },
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(0),
          marginRight: px(0),
          marginBottom: px(15),
          marginLeft: px(0),
        },
      },
    },
  },
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_ADD_TO_CART_FORM
  )(CommerceAddToCartForm),

  fields: {children: TListOfElement},
});

export default config;
